import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "lucide-react";
type Crumb = {
  label: string;
  to?: string;
};
type BreadcrumbProps = {
  items: Crumb[];
};
export function Breadcrumb({
  items
}: BreadcrumbProps) {
  return <nav aria-label="Breadcrumb" data-id="element-428" data-mp="3avhx8vt2o3fs">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-slate" data-id="element-429" data-mp="3ex3h5140xhzh">
        {items.map((item, index) => <li key={item.label} className="flex items-center gap-1.5" data-id="element-430" data-mp="30xaqf5shz1ri" data-mpi={index}>
            {item.to ? <Link to={item.to} className="underline-offset-4 hover:text-charcoal hover:underline" data-id="element-431" data-mp="35wx41gc8mk0u">
                {item.label}
              </Link> : <span aria-current="page" className="text-charcoal" data-id="element-432" data-mp="2vyheviwrtktz">
                {item.label}
              </span>}
            {index < items.length - 1 && <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-433" data-mp="q60sy410rav4" />}
          </li>)}
      </ol>
    </nav>;
}